import React, { useEffect, useState } from "react";
import { SectionContainer, MainTitle, Content } from "./styles";
import fluxoCaixa from "../../assets/1.png";
import agendamento from "../../assets/2.png";
import consultoria from "../../assets/3.png";
import calculadora from "../../assets/4.png";
import das from "../../assets/5.png";
import indicadores from "../../assets/6.png";
import galeria from "../../assets/7.png";
import local from "../../assets/8.png";
import calendario from "../../assets/9.png";
import respostas from "../../assets/10.png";
import quest from "../../assets/11.png";
import maisProximo from "../../assets/12.png";
import assistente from "../../assets/13.png";
import diagnostico from "../../assets/14.png";
import parceiro from "../../assets/15.png";
import gestao from "../../assets/16.png";
import redeSocial from "../../assets/17.png";
import ia from "../../assets/18.png";
import { SwiperImg } from "../../../../components/SwiperImg";

const images: any[] = [
  fluxoCaixa,
  agendamento,
  consultoria,
  calculadora,
  das,
  indicadores,
  galeria,
  local,
  calendario,
  respostas,
  quest,
  maisProximo,
  assistente,
  diagnostico,
  parceiro,
  gestao,
  redeSocial,
  ia,
];

const Integration = () => {
  const [slidesPerView, setSlidesPerView] = useState(4);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        if (slidesPerView !== 1) setSlidesPerView(1);
      } else if (window.innerWidth < 768) {
        if (slidesPerView !== 2) setSlidesPerView(2);
      } else if (slidesPerView !== 4) {
        setSlidesPerView(4);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [slidesPerView]);

  return (
    <SectionContainer>
      <MainTitle>
        Veja as funcionalidade que podemos agregar a seu negócio
      </MainTitle>
      <Content>
        <SwiperImg
          swiperStyle={{ paddingBottom: "3rem" }}
          slidesPerView={slidesPerView}
          slidesPerGroup={slidesPerView}
          img={images}
          imageStyle={{ width: "100%" }}
        />
      </Content>
    </SectionContainer>
  );
};

export default Integration;
